import { render } from "./FormaPago_SuscripcionAud.vue?vue&type=template&id=96a20598"
import script from "./FormaPago_SuscripcionAud.vue?vue&type=script&lang=js"
export * from "./FormaPago_SuscripcionAud.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__